import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\GetRoomOccupationController::__invoke
* @see app/Http/Controllers/Screen/GetRoomOccupationController.php
* @route '/api/screen/data/get-room-occupation'
*/
const GetRoomOccupationController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetRoomOccupationController.url(options),
    method: 'get',
})

GetRoomOccupationController.definition = {
    methods: ["get","head"],
    url: '/api/screen/data/get-room-occupation',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Screen\GetRoomOccupationController::__invoke
* @see app/Http/Controllers/Screen/GetRoomOccupationController.php
* @route '/api/screen/data/get-room-occupation'
*/
GetRoomOccupationController.url = (options?: RouteQueryOptions) => {
    return GetRoomOccupationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\GetRoomOccupationController::__invoke
* @see app/Http/Controllers/Screen/GetRoomOccupationController.php
* @route '/api/screen/data/get-room-occupation'
*/
GetRoomOccupationController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetRoomOccupationController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Screen\GetRoomOccupationController::__invoke
* @see app/Http/Controllers/Screen/GetRoomOccupationController.php
* @route '/api/screen/data/get-room-occupation'
*/
GetRoomOccupationController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetRoomOccupationController.url(options),
    method: 'head',
})

export default GetRoomOccupationController